import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
import { AttendanceStatusEnum, AttendanceStatusNameEnum } from "../Types";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function generateCostCode(price: number, alphabet: string): string {
  const cleanAlphabet = (alphabet || "").trim();
  const isInt = Math.floor(price) === price;
  const inputStr = isInt ? price.toString() : price.toFixed(2);

  if (cleanAlphabet.length < 10) {
    return inputStr;
  }

  const cipher = cleanAlphabet.toUpperCase().padEnd(11, "X");
  const digitToLetter: Record<string, string> = {};
  for (let i = 0; i < 10; i++) {
    digitToLetter[i.toString()] = cipher[i] || "X";
  }
  const repeatChar = cipher[10] || "X";
  digitToLetter["."] = ".";

  let result = "";
  let lastChar: string | null = null;
  for (let i = 0; i < inputStr.length; i++) {
    const char = inputStr[i];
    if (char === lastChar && char !== ".") {
      result += repeatChar;
    } else {
      result += digitToLetter[char] ?? char;
    }
    lastChar = char;
  }
  return result;
}

export const fmtLKR = (v: number): string =>
  v.toLocaleString(undefined, { minimumFractionDigits: 2 });

export const getAttendanceStatusColor = (status: string | null | undefined): string => {
  if (!status) return "default";
  const s = status.toLowerCase().trim();
  if (
    s === AttendanceStatusEnum.PRESENT.toLowerCase() ||
    s === AttendanceStatusNameEnum.PRESENT.toLowerCase()
  ) {
    return "success";
  }
  if (
    s === AttendanceStatusEnum.ABSENT.toLowerCase() ||
    s === AttendanceStatusNameEnum.ABSENT.toLowerCase()
  ) {
    return "error";
  }
  if (
    s === AttendanceStatusEnum.LATE.toLowerCase() ||
    s === AttendanceStatusNameEnum.LATE.toLowerCase()
  ) {
    return "warning";
  }
  if (
    s === AttendanceStatusEnum.HALF_DAY.toLowerCase() ||
    s === AttendanceStatusNameEnum.HALF_DAY.toLowerCase() ||
    s === "half_day"
  ) {
    return "processing";
  }
  return "default";
};
